import React from "react";
import { AUTOPILOT_COLORS } from "../autopilot/styles";

// Badge dirigido por dado (PO1-2491): indica se o tributo (ICMS/ISS) compõe o total
// esperado do CT-e. incide=true -> "ICMS incide"; false -> "não incide · informativo"
// (ex.: ICMS embutido no frete, que aparece como linha mas não soma no total).
export default function TributoIncideBadge({ incide, tipo }) {
  if (typeof incide !== "boolean") return null;

  const label = incide ? `${tipo || "Tributo"} incide` : "não incide · informativo";
  const color = incide ? AUTOPILOT_COLORS.statusInfo : AUTOPILOT_COLORS.muted;
  const borderColor = incide ? AUTOPILOT_COLORS.statusInfo : AUTOPILOT_COLORS.border;

  return (
    <span
      title={
        incide
          ? "O tributo compõe o total esperado (simulado)."
          : "Tributo informativo: aparece no CT-e mas não compõe o total esperado."
      }
      style={{
        marginLeft: "0.5rem",
        fontSize: "0.6rem",
        fontWeight: 700,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        padding: "0.1rem 0.4rem",
        borderRadius: "0.4rem",
        whiteSpace: "nowrap",
        color,
        border: `1px solid ${borderColor}`,
        background: "transparent",
        verticalAlign: "middle",
      }}
    >
      {label}
    </span>
  );
}
